import { useEffect, useState } from 'react';

import { activateWaitingServiceWorker } from '../pwa';

export function ReleaseStatus() {
  const [updateReady, setUpdateReady] = useState(false);
  const [offline, setOffline] = useState(() => !navigator.onLine);

  useEffect(() => {
    const showUpdate = () => setUpdateReady(true);
    const showOffline = () => setOffline(true);
    const showOnline = () => setOffline(false);
    window.addEventListener('brick-rogue:update-ready', showUpdate);
    window.addEventListener('offline', showOffline);
    window.addEventListener('online', showOnline);
    return () => {
      window.removeEventListener('brick-rogue:update-ready', showUpdate);
      window.removeEventListener('offline', showOffline);
      window.removeEventListener('online', showOnline);
    };
  }, []);

  useEffect(() => {
    if (!updateReady) {
      return undefined;
    }
    const handleShortcut = (event: KeyboardEvent) => {
      if (event.key.toLowerCase() !== 'r') {
        return;
      }
      event.preventDefault();
      void activateWaitingServiceWorker();
    };
    window.addEventListener('keydown', handleShortcut);
    return () => window.removeEventListener('keydown', handleShortcut);
  }, [updateReady]);

  if (!updateReady && !offline) {
    return null;
  }
  return (
    <aside className="release-status" role="status" aria-live="polite">
      <span>{updateReady ? '新版本已就绪' : '当前处于离线模式'}</span>
      {updateReady ? (
        <button type="button" onClick={() => void activateWaitingServiceWorker()}>
          立即更新（R）
        </button>
      ) : null}
    </aside>
  );
}
